var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"center-all my-5"},[_c('h1',[_vm._v(_vm._s(_vm.$t('games.name'))+" : "+_vm._s(_vm.gameName))])]),_c('setting'),_c('slides-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }